import { Box } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import React from 'react'
import { HeroTextTwoColumnSectionProps } from 'types/heroTextSection'
import RichText from '../RichText'
import backgroundAlpha from '@talentinc/gatsby-theme-ecom/images/hero_alpha.png'
import specialList from '@talentinc/gatsby-theme-ecom/images/special-list.png'

function HeroTextTwoColumnCenteredSection(
  props: HeroTextTwoColumnSectionProps
) {
  const { classes, cx } = useStyles()
  const { row, sectionClass } = props

  return (
    <Box
      id="heroCenteredBackgroundV2Wrapper"
      className={cx(classes.mainPadding, sectionClass, classes.container)}
    >
      <Box className={classes.innerContainer}>
        <Box className={cx(classes.column, classes.column1)}>
          <RichText
            cssEntries={row.css}
            rawBody={row.column1.raw}
            references={row.column1.references}
          />
          <img className={classes.mobileImgBottom} src={specialList} alt="" />
        </Box>
        <Box className={cx(classes.column, classes.column2)}>
          <RichText
            cssEntries={row.css}
            rawBody={row.column2.raw}
            references={row.column2.references}
          />
        </Box>
      </Box>
    </Box>
  )
}

const useStyles = makeStyles()((theme) => ({
  innerContainer: {
    borderRadius: '24px',
    background: `right bottom / 55% no-repeat url(${backgroundAlpha}) ${theme.colors.blue[10]}`,
    backgroundBlendMode: 'multiply',
    display: 'flex',
    flex: 1,
    gap: '4rem',
    padding: '77px 64px',
    [theme.breakpoints.down(theme.breakpoints.values.tablet)]: {
      padding: '40px 24px',
      paddingBottom: 0,
      borderRadius: '20px',
      background: `bottom / 120% no-repeat url(${backgroundAlpha}) ${theme.colors.blue[10]}`,
    },
  },
  container: {
    alignItems: 'center',
    display: 'none',
    flexDirection: 'row',
    width: '100%',
  },
  mainPadding: {
    paddingBottom: '4rem',
    paddingTop: '4rem',
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
  },
  column1: {
    flex: 3,
    '& > h1': {
      fontWeight: 400,
    },
    justifyContent: 'center',
    '& > p': {
      marginBottom: '1rem',
      fontSize: '23px',
      [theme.breakpoints.down(theme.breakpoints.values.tablet)]: {
        fontSize: '20px',
      },
    },
    '& > a': {
      [theme.breakpoints.up(theme.breakpoints.values.tablet)]: {
        maxWidth: '50%',
      },
    },
    [theme.breakpoints.down(theme.breakpoints.values.tablet)]: {
      textAlign: 'center',
    },
  },
  column2: {
    flex: 2,
    alignItems: 'flex-end',
    [theme.breakpoints.down(theme.breakpoints.values.tablet)]: {
      display: 'none',
    },
  },
  mobileImgBottom: {
    [theme.breakpoints.up(theme.breakpoints.values.tablet)]: {
      display: 'none',
    },
    width: '85%',
    height: 'auto',
    margin: '0 auto',
  },
}))

export default HeroTextTwoColumnCenteredSection
